<div class="concept-dialog">
  <div class="dialog-header">
    <h3 class="dialog-title">Concept filter</h3>
    <button type="button" class="close-btn" (click)="handleCancel()" aria-label="Close">
      <img src="assets/icons/close.svg" alt="Close" />
    </button>
  </div>

  <label class="field-label" for="concept-text">Concept</label>
  <textarea
    id="concept-text"
    class="concept-textarea"
    rows="4"
    [(ngModel)]="conceptText"
    placeholder="e.g. Customers calling about flight delays, missed connections, or weather-related disruptions…"
    [disabled]="loadingSuggest"
  ></textarea>

  <div class="suggest-row">
    <button type="button" class="primary-btn" (click)="handleSuggest()" [disabled]="!canSuggest">
      {{ loadingSuggest ? 'Suggesting…' : 'Suggest' }}
    </button>
  </div>

  <div class="warnings" *ngIf="warnings.length">
    <div class="warning-item" *ngFor="let warning of warnings">{{ warning }}</div>
  </div>

  <div class="suggestions-panel" *ngIf="groupedSuggestions.length">
    <div class="suggestions-header">
      <span>Suggested filters</span>
      <span class="combine-hint">Combine with {{ combineWith }}</span>
    </div>

    <div class="group-block" *ngFor="let group of groupedSuggestions">
      <label class="group-header">
        <input
          type="checkbox"
          [checked]="isGroupFullySelected(group)"
          [indeterminate]="isGroupPartiallySelected(group)"
          (change)="toggleGroup(group, $any($event.target).checked)"
        />
        <span class="group-name">{{ group.group }}</span>
      </label>

      <label class="suggestion-row" *ngFor="let item of group.items">
        <input type="checkbox" [checked]="item.selected" (change)="toggleSuggestion(item)" />
        <div class="suggestion-body">
          <div class="suggestion-label">{{ item.label }}</div>
          <div class="suggestion-meta" *ngIf="item.reason">{{ item.reason }}</div>
        </div>
        <span class="score" *ngIf="item.score != null">{{ item.score | number: '1.0-2' }}</span>
      </label>
    </div>
  </div>

  <div class="save-section" *ngIf="selectedSuggestions.length">
    <button type="button" class="link-btn" (click)="toggleSaveForm()">
      {{ showSaveForm ? 'Hide save form' : 'Save as Concept filter' }}
    </button>

    <div class="save-form" *ngIf="showSaveForm">
      <label class="field-label" for="concept-save-name">Name</label>
      <input
        id="concept-save-name"
        type="text"
        class="text-input"
        [(ngModel)]="saveName"
        placeholder="Concept filter name"
        [disabled]="loadingSave"
      />

      <label class="field-label" for="concept-save-desc">Description (optional)</label>
      <input
        id="concept-save-desc"
        type="text"
        class="text-input"
        [(ngModel)]="saveDescription"
        placeholder="Short description"
        [disabled]="loadingSave"
      />

      <label class="toggle-row">
        <input type="checkbox" [(ngModel)]="isGlobal" [disabled]="loadingSave" />
        <span>Share with all dashboard users (global)</span>
      </label>

      <button
        type="button"
        class="secondary-btn"
        (click)="handleSave()"
        [disabled]="loadingSave || !saveName.trim()"
      >
        {{ loadingSave ? 'Saving…' : 'Save' }}
      </button>
    </div>
  </div>

  <div class="dialog-actions">
    <button type="button" class="cancel-btn" (click)="handleCancel()">Cancel</button>
    <button type="button" class="primary-btn" (click)="handleOk()" [disabled]="!canOk">OK</button>
  </div>
</div>
